import React from "react";
import { Button, ButtonGroup } from "reactstrap";
export const ZoomComponent = ({ zoom, prop, updateMethod }) => {
  return (
    <div className="reservation-schedule-zoom">
      <ButtonGroup>
        <Button
          color={"faiz1"}
          onClick={() => {
            updateMethod([{ prop: prop, value: zoom - 1 }]);
          }}
        >
          <i className="fa fa-search-minus " style={{ color: "white" }} />
        </Button>
        <div style={{ backgroundColor: "white", display: "flex", justifyContent: "center", alignItems: "center" }}>
          {/* <input style={{ width: 30, textAlign: "center", marginLeft: 5, marginRight: 5 }} value={zoom} /> */}
          <span style={{ width: 30, textAlign: "center", marginLeft: 5, marginRight: 5 }}>{zoom}</span>
        </div>
        <Button
          color={"faiz1"}
          onClick={() => {
            updateMethod([{ prop: prop, value: zoom + 1 }]);
          }}
        >
          <i className="fa fa-search-plus " style={{ color: "white" }} />
        </Button>
      </ButtonGroup>
    </div>
  );
};
